import { type TFunction } from "i18next"

const APPOINTMENT_DEFAULT_MINUTES = 60
const FOLLOW_UP_DEFAULT_MINUTES = 15

/** The lengths the Calendar's own 15-minute grid can express as one block. */
const DURATION_MINUTES = [15, 30, 45, 60, 75, 90, 120, 180, 240]

const durationLabel = (minutes: number, t: TFunction) => {
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60

  if (!hours) return t("leadWorkspace.header.duration.minutes", { count: rest })
  if (!rest) return t("leadWorkspace.header.duration.hours", { count: hours })

  return t("leadWorkspace.header.duration.hoursAndMinutes", {
    hours: t("leadWorkspace.header.duration.hours", { count: hours }),
    minutes: t("leadWorkspace.header.duration.minutes", { count: rest })
  })
}

const durationOptions = (t: TFunction) =>
  DURATION_MINUTES.map((minutes) => ({
    value: minutes,
    label: durationLabel(minutes, t)
  }))

export {
  APPOINTMENT_DEFAULT_MINUTES,
  DURATION_MINUTES,
  FOLLOW_UP_DEFAULT_MINUTES,
  durationLabel,
  durationOptions
}
